import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import TicketIcon from '../components/CustomIcons/TicketIcon';
import ReportIcon from '../components/CustomIcons/ReportIcon';
import QueueIcon from '../components/CustomIcons/QueueIcon';
import { getStoredThemeMode, resolveDarkTheme } from '../services/themeMode';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        dark: resolveDarkTheme(getStoredThemeMode()),
        default: 'light',
        themes: {
            light: {
                primary: '#122448',
            },
            dark: {
                primary: '#82B1FF',
            },
        },
    },
    icons: {
        iconfont: 'mdi',
        values: {
            ticketIcon: {
                component: TicketIcon
            },
            reportIcon: {
                component: ReportIcon
            },
            queueIcon: {
                component: QueueIcon
            },
        }
    }
});

export default vuetify;
